/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Typography } from '@mui/material'
import { current } from '@reduxjs/toolkit'
import React, {useState} from 'react'
import ArgosButton from '../../Buttons/ArgosButton'
import ArgosFlexbox from '../../Containers/ArgosFlexbox'
import ArgosTextField from '../../Form/TextField/ArgosTextField'

const EditDrivingScenarioRowDialog = (props: any) => {
    const limits = props.data.original
    const [currentRowData, setCurrentRowData] =  useState<any>(props.data.original)
    const [isValidData, setIsValidData] = useState<any>(true)
    const handleTextFieldChange = (textField: string, newValue: any) => {
        let localIsValidData = true;
       
        switch(textField) {
            case "min":
                localIsValidData = newValue <= limits.max && newValue >= limits.min
                break;
            case "max":
                localIsValidData = newValue <= limits.max && newValue >= limits.min
                break;
            case "totalSteps":
                localIsValidData = newValue >= 1
                break;
        }
        
        if(localIsValidData){
            let newData = {
                ...currentRowData, 
                [textField] : newValue
            }
            setCurrentRowData(newData)
            if(newValue =="")
                setIsValidData(false)
            else
                setIsValidData(localIsValidData)
        }
    }   
    const handleSave = () => {
        props.onClose()
        props.handleRowChange(currentRowData)
        
    }
    return (<>
        <ArgosFlexbox vertical> 
    
             <ArgosTextField 
                label="Min"
                value={currentRowData.min}
                onChange={(e) => handleTextFieldChange("min", e.target.value)}
                helperText={`Please enter a value between ${limits.min} and ${limits.max}`}
                required
                type="number"
            />
            <ArgosTextField 
                label="Max"
                value={currentRowData.max}
                onChange={(e) => handleTextFieldChange("max", e.target.value)}
                helperText={`Please enter a value between ${limits.min} and ${limits.max}`}
                required
                type="number"
                />
            <ArgosTextField 
                label="Total Steps"
                value={currentRowData.totalSteps}
                onChange={(e) => handleTextFieldChange("totalSteps", e.target.value)}
                helperText="Please enter a value greater than 1"
                required
                type="number"
            />
            <ArgosTextField
                label="Rationale"
                value={currentRowData.rationale}
                onChange={(e) => handleTextFieldChange("rationale", e.target.value)}
            />
            
            <ArgosFlexbox style={{justifyContent: "center"}}>
                <ArgosButton onClick={props.onClose}>
                    Cancel
                </ArgosButton>
                <ArgosButton onClick={handleSave} disabled={!isValidData}>
                    Save
                </ArgosButton>
            </ArgosFlexbox>
        </ArgosFlexbox>
    </>)
}
export { EditDrivingScenarioRowDialog };